import { alertSrc } from '../../assets';

/** Единый контент для подтверждения ухода без сохранения — в history guard и обычных confirm-модалках. */
export const UNSAVED_CHANGES_CONFIRM = {
    title: 'Изменения не сохранены',
    bodyText: 'Если продолжить, несохранённые изменения будут потеряны.',
    applyText: 'Продолжить без сохранения',
    cancelText: 'Вернуться к редактированию',
    imageSrc: alertSrc,
} as const;
